__turbopack_context__.v({
  "bottomOnly": "WaveyWrapper-module__sEeYMG__bottomOnly",
  "bright": "WaveyWrapper-module__sEeYMG__bright",
  "contentContainer": "WaveyWrapper-module__sEeYMG__contentContainer",
  "dark": "WaveyWrapper-module__sEeYMG__dark",
  "outerContainer": "WaveyWrapper-module__sEeYMG__outerContainer",
  "topOnly": "WaveyWrapper-module__sEeYMG__topOnly",
});
